// extracted by mini-css-extract-plugin
module.exports = {"arrow_button":"ArrowButton_arrow_button__e79X5"};